module.exports = __webpack_public_path__ + "img/bnr_footer01.9a0bdb39.png";